<template>
    <div class="container ">
         <form>
        <div class="row ">
            <h3 class="text-center mt-4">რეგისტრაცია</h3>

            <div class="col-6 mt-3">
  
              
  <div class="mb-3">
  
    <input type="text" class="form-control"  placeholder="სახელი" v-model="fname">
   
  </div>
  <div class="mb-3">
  
    <input type="text" class="form-control"  placeholder="გვარი" v-model="lname">
  </div>

    <div class="mb-3">
  
    <input type="text" class="form-control"  placeholder="სახელი EN" v-model="fnameeng">
   
  </div>
  <div class="mb-3">
  
    <input type="text" class="form-control"  placeholder="გვარი EN" v-model="lnameeng">
  </div>

                
 

<div class="mb-3">

     <label for="start">დაბადების თარიღი: </label> 

      <input type="date"  class="form-control"  v-model="dob"/>
   </div>
  
      <div class="mb-3">
        <label for="start">სრულწლოვანი </label> 
        <div class="form-check">
  <input class="form-check-input" type="radio" value="1"   name="age" v-model="age">
  <label class="form-check-label" for="flexCheckDefault">
    კი
  </label>
</div>
<div class="form-check">
  <input class="form-check-input" type="radio" value="0" name="age" v-model="age" >
  <label class="form-check-label" for="flexCheckChecked">
    არა
  </label>
</div>
    
   
  </div>
      <div class="mb-3">
  
    <input type="text" class="form-control"   placeholder="პირადობის ნომერი" v-model="pn">
   
  </div>
  <div class="mb-3" v-if="age==0">
  <p>დაბადების მოწმოება</p>
  <input type="file" class="form-control" @change="getDabadebisMow">
  
</div>
<div class="mb-3" v-if="age==0">
    <input type="text" class="form-control" placeholder="მშობლის  პირადობა" v-model="parrentPN" >
</div>

 <div class="mb-3">
   <input type="text" class="form-control"  placeholder="მისამართი" v-model="address">
  </div>
   <div class="mb-3">
  
    <input type="text" class="form-control" placeholder="დაბადების ადგილი" v-model="birthPlace">
   
  </div>
  <div class="mb-3">
    <input type="text" placeholder="სასწავლო დაწესებულება" class="form-control" v-model="school_usd"/>
  </div>

  <div class="mb-3">

<label for="avatar">ატესტატის/დიპლომის ატვირთვა: </label>

<input type="file" class="form-control"  @change="getAtDip"/>

</div>
    
<div class="mb-3">
  <select class="form-select" v-model="citizenshipID">
  <option value="0">მოქალაქეობა...</option>
  <option v-for="citizenship in citizenships" :key="citizenship.citizenshipID" :value="citizenship.citizenshipID">{{citizenship.citizenship}}</option>
 
</select>
</div>

<div class="mb-3">
  <div class="mb-3">
        <label for="start">მინდობილობა  </label> 
        <div class="form-check">
  <input class="form-check-input" type="radio" value="1" id="flexCheckDefault" name="mindobiloba" v-model="mindobiloba">
  <label class="form-check-label" for="flexCheckDefault">
    კი
  </label>
</div>
<div class="form-check">
  <input class="form-check-input" type="radio" value="0" id="flexCheckChecked" name="mindobiloba" v-model="mindobiloba" >
  <label class="form-check-label" for="flexCheckChecked">
    არა
  </label>
</div>
    
   
  </div>
      <div class="mb-3" v-if="mindobiloba==1">
  
    <input type="text" class="form-control" placeholder="მინდობილი პირის სახელი გვარი" v-model="mindobilifullname">
   
  </div>
  <div class="mb-3" v-if="mindobiloba==1">
  
  <input type="text" class="form-control" placeholder="მინდობილი პირის მობილური" v-model="mindobiliphone">
  
</div>
<div class="mb-3" v-if="mindobiloba==1">
    <input type="text" class="form-control" placeholder="მინდობილი პირის პ/ნ" v-model="mindobilipn">
</div>

</div>

    </div>


            <div class="col-6   ">

              
  <div class="mb-3">
    <p>სურათი</p>
    <input type="file" class="form-control" @change="getPhoto">
  </div>
  <div class="mb-3">
  <select class="form-select" v-model="programID">
  <option value="0">პროგრამა...</option>
  <option v-for="program in programs" :key="program.programID" :value="program.programID">{{program.program_name}}</option>
 
</select>
  </div>

  <div class="mb-3">
   <h6>სქესი:</h6>
    <label class="form-check-label" for="exampleRadios1">მდედრ.  </label> 

  <input class="form-check-input ms-2" type="radio" id="checkboxNoLabel" value="0" name="gender" v-model="gender">
      <label class="form-check-label ms-2" for="exampleRadios1">მამრ.</label> 
  
  <input class="form-check-input ms-2" type="radio" id="checkboxNoLabel" value="1" name="gender" v-model="gender">
  </div>
   <div class="mb-3">
  
    <input type="email" class="form-control"  placeholder="მეილი" v-model="email">
   
  </div>

 <div class="mb-3">
    <input type="number"  class="form-control" placeholder="მობილური" v-model="phone">
 </div>


 <div class="mb-3">
  
  <input type="text" class="form-control"  placeholder="მშობლის სახელი (დედა)" v-model="motherfname">
 
</div>
<div class="mb-3">

  <input type="text" class="form-control"  placeholder="მშობლის გვარი (დედა)" v-model="motherlname">
</div>

<div class="mb-3">
    <input type="number"  class="form-control" placeholder="მშობლის საკონტაქტო ნომერი (დედა)" v-model="motherPhone">
 </div>
              
<div class="mb-3">
  
  <input type="text" class="form-control"  placeholder="მშობლის სახელი (მამა)" v-model="fatherfname">
 
</div>
<div class="mb-3">

  <input type="text" class="form-control"  placeholder="მშობლის გვარი (მამა)" v-model="fatherlname">
</div>

<div class="mb-3">
    <input type="number"  class="form-control" placeholder="მშობლის საკონტაქტო ნომერი (მამა)" v-model="fatherphone">
 </div>




<div class="mb-3">

     <label for="start">პროგრამის დაწყების თარიღი </label> 

      <input type="date"  class="form-control" v-model="program_start"/>
 </div>
 <div class="mb-3">

<label for="start">პროგრამის დასრულების სავარაუდო თარიღი </label> 

  <input type="date"  class="form-control"  v-model="program_end" />
</div>
<div class="mb-3">

<input type="text" class="form-control"  placeholder="ჩარიცხვის ბრძანების ნომერი" v-model="orderNum">
</div>

<div class="mb-3">

<label for="start">ჩარიცხვის ბრძანების თარიღი:  </label> 

  <input type="date"  class="form-control" v-model="order_date"/>
</div>

<div class="d-grid gap-2">
 
  <button class="btn btn-registration" type="button" @click="saveStudent()">რეგისტრაცია</button>
</div>


                




            </div>

        </div>
         </form>
    </div>
</template>

<script>
import HttpRequests from '../httpRequests/httpRequests'
const httpRequests=new HttpRequests()
  export default{
    data(){
      return{
        fname:null,
        lname:null,
        fnameeng:null,
        lnameeng:null,
        dob:null,
        age:1,
        pn:null,
        parrentPN:null,
        address:null,
        birthPlace:null,
        school_usd:null,
        citizenshipID:0,
        mindobiloba:0,
        mindobilifullname:null,
        mindobiliphone:null,
        mindobilipn:null,
        programID:0,
        gender:1,
        email:null,
        phone:null,
        motherfname:null,
        motherlname:null,
        motherPhone:null,
        fatherfname:null,
        fatherlname:null,
        fatherphone:null,
        program_start:null,
        program_end:null,
        orderNum:null,
        order_date:null,
        photo:null,
        dabadebisMowmoba:null,
        atDiploma:null,


        programs:[],
        citizenships:[]

      }
    },
    mounted(){
      httpRequests.getPrograms().then(response=>{
        this.programs=response.data
      })

      httpRequests.citizenship().then(response=>{
        this.citizenships=response.data
      })
    },
    methods:{
      getPhoto(e){
        this.photo=e.target.files[0]
      },
      getDabadebisMow(e){
        this.dabadebisMowmoba=e.target.files[0]
      },
      getAtDip(e){
        this.atDiploma=e.target.files[0]
      },
      saveStudent(){

          let formData=new FormData()

          formData.append('fname',this.fname)
          formData.append('lname',this.lname)
          formData.append('fnameeng',this.fnameeng)
          formData.append('lnameeng',this.lnameeng)
          formData.append('dob',this.dob)
          formData.append('age',this.age)
          formData.append('pn',this.pn)
          formData.append('parrentPN',this.parrentPN)
          formData.append('address',this.address)
          formData.append('birthPlace',this.birthPlace)
          formData.append('school_usd',this.school_usd)
          formData.append('citizenshipID',this.citizenshipID)
          formData.append('mindobiloba',this.mindobiloba)
          formData.append('mindobilifullname',this.mindobilifullname)
          formData.append('mindobiliphone',this.mindobiliphone)
          formData.append('mindobilipn',this.mindobilipn)
          formData.append('programID',this.programID)
          formData.append('gender',this.gender)
          formData.append('email',this.email)
          formData.append('phone',this.phone)
          formData.append('motherfname',this.motherfname)
          formData.append('motherlname',this.motherlname)
          formData.append('motherPhone',this.motherPhone)
          formData.append('fatherfname',this.fatherfname)
          formData.append('fatherlname',this.fatherlname)
          formData.append('fatherphone',this.fatherphone)
          formData.append('program_start',this.program_start)
          formData.append('program_end',this.program_end)
          formData.append('orderNum',this.orderNum)
          formData.append('order_date',this.order_date)
          formData.append('photo',this.photo)
          formData.append('dabadebisMowmoba',this.dabadebisMowmoba)
          formData.append('atDiploma',this.atDiploma)
         

          

        httpRequests.saveStudent(formData).then(()=>{
          location.reload()
        })
          




      }
    }



  }

</script>